export default function i18n(translatableString) {
  if (window.reactTranslations) {
    const translation = window.reactTranslations.find(
      translationElement => translationElement.key === translatableString
    );
    if (translation && translation.value) {
      return translation.value;
    }
  }
  return translatableString;
}
